export default __webpack_public_path__ + "static/media/WhatsApp Image 2023-08-08 at 20.06.23.9dd8a8f2.jpeg";